import React, { Suspense } from "react";
import { Navigate, useParams } from "react-router-dom";

import ComponentLoader from "@performyard/py-components/src/components/atoms/ComponentLoader";

import { useRbacObjectPermissions } from "../../../api/hooks/defs/rbac";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

const LazyEdit360FormSettingsPage = React.lazy(() => import("./Edit360FormSettingsPage"));

const CenteredLoader = () => (
	<div className="flex h-[calc(100vh-104px)] w-full items-center justify-center">
		<ComponentLoader />
	</div>
);

const Edit360FormSettingsGate = () => {
	const { cycleId = "" } = useParams();
	const { value: optionsRefreshEnabled, query: flagQuery } = useFeatureFlagQuery(
		"ff-temp-is-review-cycle-options-refresh-enabled",
		false
	);
	const { data: permissions } = useRbacObjectPermissions("review", cycleId);

	if (!flagQuery.isFetched || permissions === undefined) {
		return <CenteredLoader />;
	}

	if (!optionsRefreshEnabled || !permissions.includes("review_cycle:editCycle")) {
		return <Navigate to={`/review-cycle/${cycleId}/`} replace />;
	}

	return (
		<Suspense fallback={<CenteredLoader />}>
			<LazyEdit360FormSettingsPage cycleId={cycleId} />
		</Suspense>
	);
};

export default Edit360FormSettingsGate;
